// @flow
import React, { Component } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./Store/store";
import { CookiesProvider } from "react-cookie";
import moment from "moment";
import "moment/locale/tr";
import Moment from "react-moment";
import CookieWorker from "./Utilities/Workers/CookieWorker";
import App from "./Containers/App.js";

type PropsType = {};
type StateType = {};

// Moment Global Settings
Moment.globalMoment = moment;
Moment.globalLocale = "tr";
Moment.globalFormat = "DD MMMM YYYY";

class EnvanteriumLanding extends Component<PropsType, StateType> {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <CookiesProvider>
            <CookieWorker />
            <App />
          </CookiesProvider>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default EnvanteriumLanding;



// WEBPACK FOOTER //
// ./src/EnvanteriumLanding.js